var map = {
	"./account-grey24.svg": "4316",
	"./account-grey56.svg": "97d5",
	"./account-white.svg": "3295",
	"./account-white_new.svg": "40a0",
	"./add-white.svg": "431c",
	"./adjust-grey56.svg": "5a41",
	"./alarm-warning-dent-red.svg": "a0ce",
	"./api-white.svg": "6b84",
	"./arrow-right-filled-white.svg": "2a7f",
	"./back-white.svg": "addf",
	"./calendar-grey24.svg": "1c77",
	"./calendar-lightgrey24.svg": "e7d4",
	"./chart-candle-dark-grey.svg": "3593",
	"./chart-candle-grey.svg": "f242",
	"./check-circle-green.svg": "d370",
	"./check-circle-grey.svg": "fb33",
	"./check-red.svg": "2c9b",
	"./check-white.svg": "5131",
	"./close-circle-grey71.svg": "7eaf",
	"./close-circle-red.svg": "747f",
	"./close-white.svg": "72e4",
	"./coins-fullGrey.svg": "3ee1",
	"./coins-white.svg": "6a24",
	"./coins2-green.svg": "ed9d",
	"./coins2-grey.svg": "1059",
	"./coins2-red.svg": "6753",
	"./coins3-white.svg": "9c5e",
	"./copy-darkGrey.svg": "7f69",
	"./copy-gray.svg": "1ae3",
	"./copy-red.svg": "8eb6",
	"./copy-white.svg": "d787",
	"./credit-card-grey24.svg": "c4fe",
	"./crypto-dent-white.svg": "8ddc",
	"./dashboard2-fullGrey.svg": "99c2",
	"./dashboard2-white.svg": "605f",
	"./delete-grey.svg": "d8f7",
	"./delete-grey24.svg": "986c",
	"./delete-red.svg": "9cdc",
	"./docs-white.svg": "0655",
	"./download-dent-red.svg": "f83a",
	"./download-grey24.svg": "c590",
	"./download-grey56.svg": "a3e8",
	"./download-white.svg": "d959",
	"./dropdown-blob-darkgrey.svg": "be74",
	"./dropdown-blob-grey.svg": "f215",
	"./dropdown-blob-lightgrey.svg": "2277",
	"./earn-coin-white.svg": "6343",
	"./edit-dent-gray.svg": "926f",
	"./edit-dent-red.svg": "8b43",
	"./esim-grey.svg": "04f9",
	"./esim-install-orange.svg": "dde1",
	"./esim-red.svg": "7cfd",
	"./esim-white.svg": "05ed",
	"./eye-visible-white.svg": "4a52",
	"./file-grey.svg": "8699",
	"./fraud-grey24.svg": "0c43",
	"./globe-grey56.svg": "cd25",
	"./globe-nav-chevron-down-darkgrey.svg": "5521",
	"./globe-nav-chevron-down-grey.svg": "e749",
	"./globe-nav-chevron-right-dent-red.svg": "39c4",
	"./globe-nav-chevron-right-fullGrey.svg": "4d40",
	"./globe-nav-chevron-right-grey56.svg": "86dd",
	"./globe-nav-chevron-right-white.svg": "032c",
	"./globe-nav-chevron-up-darkgrey.svg": "74db",
	"./globe-nav-chevron-up-down-grey.svg": "5edf",
	"./globe-nav-chevron-up-grey.svg": "b110",
	"./graph-bar-fullGrey.svg": "b132",
	"./graph-bar-white.svg": "046f",
	"./graph-line-black.svg": "b926",
	"./graph-line-grey.svg": "1f94",
	"./hourglass-dent-red.svg": "e003",
	"./hourglass-grey24.svg": "c65f",
	"./hourglass-grey56.svg": "9ea7",
	"./info-fullGrey.svg": "3732",
	"./info-grey.svg": "0542",
	"./investment-history-fullGrey.svg": "d457",
	"./investment-history-grey56.svg": "5051",
	"./investment-history-white.svg": "0407",
	"./light-on-dent-red.svg": "85ce",
	"./lock-open-red.svg": "2029",
	"./lock-open-white.svg": "7f23",
	"./lock-red.svg": "3c7d",
	"./logout-grey56.svg": "90d2",
	"./logout-white.svg": "aa8d",
	"./market-place-fullGrey.svg": "360c",
	"./market-place-white.svg": "4ae7",
	"./mobile-data-2-grey.svg": "2eb9",
	"./mobile-data-grey24.svg": "56928",
	"./mobile-data2-grey24.svg": "f89f",
	"./plan-expired-red.svg": "dc3c",
	"./plus-white.svg": "7e53",
	"./present-white.svg": "e907",
	"./pricing-esim.svg": "da9b",
	"./qrcode-grey24.svg": "dd33",
	"./rocketman-green.svg": "db86",
	"./rocketman-white.svg": "6132",
	"./sdk-white.svg": "975a",
	"./share-white.svg": "b943",
	"./shopping-cart-green.svg": "bc59",
	"./shopping-cart-grey.svg": "3874",
	"./shopping-cart-white.svg": "dd76",
	"./smartphone-grey24.svg": "e280",
	"./support-grey24.svg": "6507",
	"./wallet-white.svg": "52cb",
	"./warning2-dent-red.svg": "1d13"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";